import { defineStore } from "pinia";
import { Ref } from "vue";
import { StorageGet, StorageSet } from "@/tools/localStorage";
import { showConfirmDialog } from "vant";
import i18n from "@/locales";
import { isMobile } from "@/modules/common";

interface State {
  enableAutoPlay: boolean;
  activatedUnMuted: boolean;
  audioRefList: Ref<HTMLAudioElement | null>[];
}

export const useAudio = defineStore("audio", {
  state: (): State => ({
    enableAutoPlay: false,
    activatedUnMuted: false,
    audioRefList: [],
  }),
  actions: {
    stopAll() {
      this.audioRefList
        .filter((audioRef) => audioRef.value && audioRef.value.currentTime > 0)
        .forEach((audioRef) => {
          audioRef.value!.pause();
          audioRef.value!.currentTime = 0;
        });
    },
    addAudioRef(audioRef: Ref<HTMLAudioElement | null>) {
      this.audioRefList.push(audioRef);
    },
    removeAudioRef(audioRef: Ref<HTMLAudioElement | null>) {
      this.audioRefList = this.audioRefList.filter(
        (ref) => ref !== audioRef
      ) as Ref<HTMLAudioElement | null>[];
    },
    async askAutoPlayIfNeed() {
      const isFirstTime =
        StorageGet("autoPlay") === null || StorageGet("autoPlay") === undefined;
      const needAsk =
        StorageGet("autoPlay") === null ||
        StorageGet("autoPlay") === undefined ||
        (this.enableAutoPlay && !this.activatedUnMuted);
      if (needAsk) {
        try {
          await showConfirmDialog({
            title: i18n.global.t("ConfirmModal.enableAutoPlay"),
            message: isFirstTime
              ? i18n.global.t("ConfirmModal.enableAutoPlayDesc")
              : i18n.global.t("ConfirmModal.enableAutoPlayDesc2"),
            confirmButtonText: i18n.global.t("ConfirmModal.autoPlayOk"),
            cancelButtonText: i18n.global.t("ConfirmModal.autoPlayCancel"),
            onConfirm: () => {
              this.setEnableAutoPlay(true);
            },
            onCancel: () => {
              this.setEnableAutoPlay(false);
            },
          });
        } catch {
          /* ignore*/
        }
      }
      return needAsk;
    },
    async askAutoPlay(ref: HTMLAudioElement) {
      await showConfirmDialog({
        title: i18n.global.t("ConfirmModal.enableAutoPlay"),
        message: i18n.global.t("ConfirmModal.enableAutoPlayDesc2"),
        confirmButtonText: i18n.global.t("ConfirmModal.autoPlayOk"),
        cancelButtonText: i18n.global.t("ConfirmModal.autoPlayCancel"),
        onConfirm: () => {
          this.setEnableAutoPlay(true);
          ref.play();
        },
        onCancel: () => {
          this.setEnableAutoPlay(false);
        },
      });
    },
    recoveryEnableAutoPlay() {
      if (
        StorageGet("autoPlay") !== null &&
        StorageGet("autoPlay") !== undefined
      ) {
        this.enableAutoPlay = StorageGet("autoPlay");
      }
    },
    setEnableAutoPlay(enableAutoPlay: boolean) {
      this.enableAutoPlay = enableAutoPlay;
      this.activatedUnMuted = true;
      StorageSet("autoPlay", enableAutoPlay);
    },
  },
});
